import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { AlleCoreRestInterface } from "./alle-core-rest.interface";
import { StoreServiceLibrary } from "../store/store.service";
import { keysUniversal } from "../../resources/keys.resources";
import { isUndefined } from "util";
import { Observable } from "rxjs";

declare var window: any;

@Injectable({
  providedIn: "root",
})
export class AlleCoreRest {

  public validaUrl = false;
  public objectSSL = null;
  static isPlatformBrowser = true;

  constructor(private _http: HttpClient, private store: StoreServiceLibrary) {
    AlleCoreRest.isPlatformBrowser = true;
  }


  isValidURLSSL(key, fpUniversal?) {
    let objectSSL = null;
    if (fpUniversal !== null && typeof fpUniversal !== 'undefined' && fpUniversal !== '') {
      objectSSL = {
        "fingerPrint": fpUniversal
      }
      return objectSSL;
    }
    const propertie = this.store.getJustOneUniversalPropertie(keysUniversal.whiteListSsl);
    if (key === null || key === undefined || propertie === '' || propertie === null) {
      return objectSSL;
    }
    const list = JSON.parse(propertie);
    list.forEach(m => {
      // console.log(m.key);
      if (key.localeCompare(m.key) === 0) {
        // this.objectSSL = m;
        objectSSL = m;
      }
    });
    return objectSSL;
  }

  callService(objectReques: AlleCoreRestInterface) {
    const that = this;
    let headers = objectReques.header != null ? objectReques.header : new HttpHeaders();
    if (objectReques && objectReques.bearerToken && objectReques.bearerToken.trim() != "") {
      headers = headers.set(
        "Authorization",
        `Bearer ${objectReques.bearerToken}`
      );
    }
    this.objectSSL = that.isValidURLSSL(objectReques.keyServicesSsl, objectReques.fpjwt);
    if (that.objectSSL !== null && !AlleCoreRest.isPlatformBrowser) {
      return new Observable((observer) => {
        that.sslCertificateCheckerURL(objectReques.url, that.objectSSL.fingerPrint).subscribe((res) => {
          that._http.post(objectReques.url, objectReques.request, { headers }).subscribe(res => {
            observer.next(res);
            observer.complete();
          }, err => {
            observer.error(err);
          });
        }, (errorSslCheckUrl) => {
          observer.error(errorSslCheckUrl);
        })
      })
    } else {
      return that._http.post(objectReques.url, objectReques.request, { headers });
    }
  }

  callServiceFormData(objectReques: AlleCoreRestInterface) {
    const that = this;
    let headers = objectReques.header != null ? objectReques.header : new HttpHeaders();
    if (objectReques && objectReques.bearerToken && objectReques.bearerToken.trim() != "") {
      headers = headers.set(
        "Authorization",
        `Bearer ${objectReques.bearerToken}`
      );
    }
    this.objectSSL = this.objectSSL = that.isValidURLSSL(objectReques.keyServicesSsl);
    if (that.objectSSL !== null && !AlleCoreRest.isPlatformBrowser) {
      return new Observable((observer) => {
        that.sslCertificateCheckerURL(objectReques.url, that.objectSSL.fingerPrint).subscribe((res) => {
          that._http.post(objectReques.url, objectReques.formData, { headers }).subscribe(res => {
            observer.next(res);
            observer.complete();
          }, err => {
            observer.error(err);
          });
        }, err => {
          return new Observable((observer) => { observer.error(err) });
        });
      });


    } else {
      return that._http.post(objectReques.url, objectReques.formData, { headers });
    }

  }

  callServiceGet(objectReques: AlleCoreRestInterface): Observable<any> {
    const that = this;
    let headers: HttpHeaders =
      objectReques.header != null ? objectReques.header : new HttpHeaders();
    // console.log('headers' + JSON.stringify(headers));

    if (objectReques && objectReques.bearerToken && objectReques.bearerToken.trim() != "") {
      headers = headers.set(
        "Authorization",
        `Bearer ${objectReques.bearerToken}`
      );
    }
    this.objectSSL = that.isValidURLSSL(objectReques.keyServicesSsl);
    if (that.objectSSL !== null && !AlleCoreRest.isPlatformBrowser) {
      return new Observable((observer) => {
        that.sslCertificateCheckerURL(objectReques.url, that.objectSSL.fingerPrint).subscribe((res) => {
          that._http.get(objectReques.url, { headers }).subscribe(res => {
            observer.next(res);
            observer.complete();

          }, err => {
            observer.error(err);
            observer.complete();
          });
        })
      })

    } else {
      return that._http.get(objectReques.url, { headers });
    }
  }

  callServiceGetWithParams(objectReques: AlleCoreRestInterface, isResponseText?: boolean) {
    const that = this;
    const headers: HttpHeaders = objectReques.header != null ? objectReques.header : new HttpHeaders();
    const urlParamsInJson: any = objectReques.urlParamsInJson != null ? objectReques.urlParamsInJson : {};


    this.objectSSL = that.isValidURLSSL(objectReques.keyServicesSsl);
    if (that.objectSSL !== null && !AlleCoreRest.isPlatformBrowser) {
      return new Observable((observer) => {
        that.sslCertificateCheckerURL(objectReques.url, that.objectSSL.fingerPrint).subscribe((res) => {
          that._http.get(objectReques.url, { headers, params: urlParamsInJson, }).subscribe(res => {
            observer.next(res);
            observer.complete();

          }, err => {
            observer.error(err);
            observer.complete();
          });
        })
      })

    } else {
      if (isResponseText) {
        return that._http.get(objectReques.url, { headers, params: urlParamsInJson, responseType: 'text' });
      } else {
        return that._http.get(objectReques.url, { headers, params: urlParamsInJson });
      }
    }
  }

  sslCertificateCheckerURL(checkURL: string, SSLFingerprint: string) {
    return new Observable((observer) => {
      window.plugins.sslCertificateChecker.check(
        (message) => {
          observer.next(message);
          observer.complete();
        },
        (errorMessage) => {
          observer.error(errorMessage);
        },
        checkURL,
        SSLFingerprint);
    });
  }

  callServiceXwwwlForm(objectReques: AlleCoreRestInterface) {
    let headers: HttpHeaders = objectReques.header != null ? objectReques.header : new HttpHeaders();
    this.objectSSL = this.isValidURLSSL(objectReques.keyServicesSsl);
    if (this.objectSSL !== null && !AlleCoreRest.isPlatformBrowser) {
      return new Observable((observer) => {
        this.sslCertificateCheckerURL(objectReques.url, this.objectSSL.fingerPrint).subscribe((res) => {
          this._http.post(objectReques.url, objectReques.request.toString(), { headers, withCredentials: true }).subscribe((resp) => {
            observer.next(resp);
            observer.complete();
          }, (err) => {
            observer.next(err);
            observer.complete();
          });
        });
      });
    } else {
      return this._http.post(objectReques.url, objectReques.request.toString(), { headers, withCredentials: true });
    }

  }

}
